const MainContainer = ({ children, className }: any) => {
  return (
    <div
    // className={`mx-auto w-full lg:w-[calc(100vw-250px)] p-8 pl-2 pt-10 max-lg:p-8 max-lg:px-4 ${className}`}
      className={`mx-auto w-full lg:w-[calc(100vw-250px)] p-8 pl-2 pt-10 max-lg:p-4 max-lg:px-2 max-lg:pt-6 max-lg:pb-20 max-w-screen overflow-x-hidden ${className}`}
    >
      {children}
    </div>
  );
};

export default MainContainer;
